module.exports = new __parcel__URL__("insight-object-view-in-object-graph-skeleton.tpl.fdc4a1a1.svg").toString();